import * as React from "react";
import Chip from "@mui/material/Chip";
import Autocomplete from "@mui/material/Autocomplete";
import TextField from "@mui/material/TextField";
import Stack from "@mui/material/Stack";

export default function Tags({ items, title }) {
  return (
    <Stack sx={{ width: "100%" }}>
      <div
        style={{
          textAlign: "left",
          fontSize: 14,
          fontFamily: "Poppins, sans-serif",
          marginTop: 15,
          marginBottom: 5,
          color: "#1D1D1D",
        }}
      >
        {title}
      </div>
      <Autocomplete
        multiple
        id="tags-filled"
        options={items.map((option) => option.title)}
        defaultValue={[items[0].title]}
        freeSolo
        renderTags={(value, getTagProps) =>
          value.map((option, index) => (
            <Chip
              variant="outlined"
              label={option}
              {...getTagProps({ index })}
            />
          ))
        }
        renderInput={(params) => (
          <TextField
            {...params}
            size="small"
            // variant="standard"
            // placeholder="Favorites"
            // InputProps={{
            //     disableUnderline: true,
            //       style: {
            //         height: 30,
            //         background: "#FFF",
            //         boxShadow: "0px 2px 5px rgba(0, 0, 0, 0.188)",
            //         borderRadius: 2,
            //         textAlign: "left",
            //         fontSize: 14,
            //         paddingLeft: 10,
            //       },
            //   }}
          />
        )}
      />
    </Stack>
  );
}
